$(function () {

  $('.skip-btn').on('click', function () {
    $(this).css({ 'display': 'none' });
    $('.animations-none').css({ 'background-image': 'none' });
    $('.animations-none').css({ 'display': 'flex' });
    $('.animations').css({ 'display': 'none' });
    $('.animations-none .main-cover').toggleClass('bk-fast');

    function animation_sk() {
      var d = new $.Deferred;
      setTimeout(function () {
        $('.animations-none .main-cover').fadeOut();
        d.resolve();
      }, 1000);
      return d.promise();
    }

    function animation_sk2() {
      var d = new $.Deferred;
      $('.animations-none #mv').fadeIn();
      $('.animations-none #mv').addClass('on');
      return d.promise();
    }

    function animation_sk3() {
      var d = new $.Deferred;
      setTimeout(function () {
        $('.animations-none #mv_title').fadeIn();
        $('.animations-none #mv_title').addClass('on');
        $('.animations-none #mv_title_sub').fadeIn();
        $('.animations-none #mv_title_sub').addClass('on');
        d.resolve();
      }, 2000);
      return d.promise();
    }

    function animation_sk4() {
      var d = new $.Deferred;
      setTimeout(function () {
        $('#menu-nav').fadeIn();
        $('body').css({ 'overflow': 'auto' });
        $('.all-content').css({ 'display': 'block' });
        $('.main').removeClass('fixed');
        $('body').removeClass('fixed').css({ 'top': 0 });
        $('.sns-block').css({ 'display': 'flex' });
        d.resolve();
      }, 2000);
      return d.promise();
    }

    animation_sk()
      .then(animation_sk2())
      .then(animation_sk3())
      .done(animation_sk4())
  });

});

function animation() {
  var d = new $.Deferred;
  $('.animations #jojo_atlas').toggleClass('on');
  // setTimeout(function() {
  // $('.animations .main-cover').toggleClass('bk');
  //
  // }, 5000);
  d.resolve();
  return d.promise();
}

function animation2() {
  var d = new $.Deferred;
  setTimeout(function () {
    // $('.animations #jojo_atlas').fadeOut(function(){
    //   $('.animations .main-cover').fadeOut();
    //   $('.skip-btn').css({'display':'none'});
    //   $('.animations').css({'background-image': 'none'});
    // });

    d.resolve();
  }, 1000);

  return d.promise();
}

function animation3() {
  var d = new $.Deferred;
  setTimeout(function () {
    // $('.animations .c1').fadeIn();

  }, 1000);
  d.resolve();
  return d.promise();
}

function animation_c1() {
  var d = new $.Deferred;
  setTimeout(function () {
    $('.animations .c1').addClass('fadein-img');
    d.resolve();
  }, 100);
  return d.promise();
}
function animation_c2() {
  var d = new $.Deferred;
  setTimeout(function () {
    $('.animations .c2').addClass('fadein-img');
    d.resolve();
  }, 500);
  return d.promise();
}
function animation_c3() {
  var d = new $.Deferred;
  setTimeout(function () {
    $('.animations .c3').addClass('fadein-img');
    d.resolve();
  }, 500);
  return d.promise();
}
function animation_c4() {
  var d = new $.Deferred;
  setTimeout(function () {
    $('.animations .c4').addClass('fadein-img');
    d.resolve();
  }, 500);
  return d.promise();
}
function animation_c5() {
  var d = new $.Deferred;
  setTimeout(function () {
    $('.animations .c5').addClass('fadein-img');
    d.resolve();
  }, 500);
  return d.promise();
}
function animation_c6() {
  var d = new $.Deferred;
  setTimeout(function () {
    $('.animations .c6').addClass('fadein-img');
    d.resolve();
  }, 500);
  return d.promise();
}

function animation_bg() {
  var d = new $.Deferred;
  // $('.animations #jojo_atlas').toggleClass('on');
  setTimeout(function () {
    $('.animations .main-cover').toggleClass('bk');
    d.resolve();
  }, 1000);

  return d.promise();
}

function animation_none() {
  var d = new $.Deferred;
  setTimeout(function () {
    $('.animations .c-layer').fadeOut();
    $('.skip-btn').css({ 'display': 'none' });
    $('.animations').css({ 'background-image': 'none' });
    d.resolve();
  }, 1500);
  return d.promise();
}

function animation_bg_none() {
  var d = new $.Deferred;
  $('.animations .main-cover').fadeOut();
  d.resolve();
  return d.promise();
}

function animation7() {
  var d = new $.Deferred;
  // $('.animations #mv').fadeIn();
  d.resolve();
  return d.promise();
}


function animation4() {
  var d = new $.Deferred;
  setTimeout(function () {
    $('.animations #mv_title').fadeIn();
    $('.animations #mv_title').addClass('on');
    d.resolve();
  }, 1500);
  d.resolve();
  return d.promise();
}

function animation5() {
  var d = new $.Deferred;
  setTimeout(function () {
    $('.animations #mv_title_sub').fadeIn();
    $('.animations #mv_title_sub').addClass('on');
    d.resolve();
  }, 1500);
  d.resolve();
  return d.promise();
}

function animation6() {
  var d = new $.Deferred;
  setTimeout(function () {
    $('#menu-nav').fadeIn();
    $('.sns-block').css({ 'display': 'flex' });
    $('.all-content').css({ 'display': 'block' });
    $('.main').removeClass('fixed');
    $('body').removeClass('fixed').css({ 'top': 0 });
    d.resolve();
  }, 1000);
  d.resolve();
  return d.promise();
}